import { render, staticRenderFns } from "./SubFlow.vue?vue&type=template&id=63a2280e&scoped=true&"
import script from "./SubFlow.vue?vue&type=script&lang=js&"
export * from "./SubFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a2280e",
  null
  
)

export default component.exports